import BadAbaIndex from '@/views/LendingStrategies/BadAba/BadAbaIndex.vue';
import BadEmployerIndex from '@/views/LendingStrategies/BadEmployer/BadEmployerIndex.vue';
import BlockedStateIndex from '@/views/LendingStrategies/BlockedState/BlockedStateIndex.vue';
import BlockedSsnIndex from '@/views/LendingStrategies/BlockedSsn/BlockedSsnIndex.vue';
import LendingStrategyLayout from '@/views/LendingStrategies/LendingStrategyLayout.vue';
import LendingStrategiesIndex from '@/views/LendingStrategies/LendingStrategiesIndex.vue';
import ScoringElementIndex from '@/views/LendingStrategies/ScoringElement/ScoringElementIndex.vue';
import ScoringModelIndex from '@/views/LendingStrategies/ScoringModel/ScoringModelIndex.vue';
import ProductAssignmentIndex from '@/views/LendingStrategies/ProductAssignment/ProductAssignmentIndex.vue';
import LendingStrategyRoute from '@/views/LendingStrategies/LendingStrategyRoute.vue';

export default [
  {
    path: 'lending-strategies',
    name: 'lending-strategies',
    component: LendingStrategyLayout,
    meta: {
      title: 'Lending Strategies',
    },
    children: [
      {
        path: 'lending-strategy',
        name: 'lending-strategy',
        component: LendingStrategiesIndex,
        meta: {
          title: 'Lending Strategies',
          permission: 'view lending-strategies::list',
        },
      },
      {
        path: 'lending-strategy-route',
        name: 'lending-strategy-route',
        component: LendingStrategyRoute,
        meta: {
          title: 'Lending Strategy Routes',
          permission: 'view lending-strategies::list',
        },
      },
      {
        path: 'scoring-element',
        name: 'scoring-element',
        component: ScoringElementIndex,
        meta: {
          title: 'Scoring Elements',
          permission: 'view lending-strategies::scoring-elements',
        },
      },
      {
        path: 'scoring-model',
        name: 'scoring-model',
        component: ScoringModelIndex,
        meta: {
          title: 'Scoring Models',
          permission: 'view lending-strategies::scoring-models',
        },
      },
      {
        path: 'product-assignment/:modelId?',
        name: 'product-assignment',
        component: ProductAssignmentIndex,
        meta: {
          title: 'Product Assignment',
          permission: 'view lending-strategies::product-assignment',
        },
      },
      {
        path: 'bad-aba',
        name: 'bad-aba',
        component: BadAbaIndex,
        meta: {
          title: 'Bad ABA',
          permission: 'view lending-strategies::bad-aba',
        },
      },
      {
        path: 'bad-employer',
        name: 'bad-employer',
        component: BadEmployerIndex,
        meta: {
          title: 'Bad Employer',
          permission: 'view lending-strategies::bad-employer',
        },
      },
      {
        path: 'blocked-state',
        name: 'blocked-state',
        component: BlockedStateIndex,
        meta: {
          title: 'Blocked State',
          permission: 'view lending-strategies::blocked-state',
        },
      },
      {
        path: 'blocked-ssn',
        name: 'blocked-ssn',
        component: BlockedSsnIndex,
        meta: {
          title: 'Blocked SSNs',
          permission: 'view lending-strategies::blocked-ssns',
        },
      },
    ],
  },
];
